import React, { useEffect } from 'react'
import './index.less'
import { effect, useStore } from '../../dva16'
import { NHomePage, EGetHomePageTopList, EGetHomePageOtherList, EGetHomePageVoiceList, EGetHomePageTopTen, EGetHotVideo } from '../../models/constants'
import FormatRichText  from '../../utils/utils'

export default () => {
  useEffect(()=>{
    effect(NHomePage, EGetHomePageTopList)
    effect(NHomePage, EGetHomePageOtherList)
    effect(NHomePage, EGetHomePageVoiceList, { categoryID: 2, page: 1, perPage: 12 })
    effect(NHomePage, EGetHomePageTopTen)
    effect(NHomePage, EGetHotVideo)
  }, [])
  let { topList, otherList, innerVoice, topTen, hotVideo } = useStore(NHomePage)
  return (
    <div className="home_page">
      <div className="layout">
        {topList ? <div className="top_list">
          <div className="left_pic">
            <img src={topList.top11Info&&topList.top11Info[0]&&topList.top11Info[0].photos&&topList.top11Info[0].photos[0]}/>
          </div>
          <div className="right_list">
            <div className="list_title">
              <div className="title">帝业人</div>
              <div className="more hoverDiv" onClick={()=>{window.location.href = '#/emperor'}}>MORE</div>
            </div>
            <div className="tips_txt hoverDiv" onClick={()=>{window.location.href = `#/detail/${topList.top11Info[0].id}`}}>{FormatRichText(topList.top11Info&&topList.top11Info[0]&&topList.top11Info[0].html)}</div>
            <div className="list_content">
              {topList.top11Info&&topList.top11Info.map((vo, index)=>{
                if(index===0){
                  return null
                }else{
                  return (
                    <div key={index} className="line hoverDiv" onClick={()=>{window.location.href = `#/detail/${vo.id}`}}>{vo.title}</div>
                  )
                }
              })}
            </div>
          </div>
        </div> : null}
        <div className="category_list">
          {
            otherList&&otherList.map((record, key)=>{
              return (
                <div className="item" key={key}>
                  <div className="item_title">{record.name}</div>
                  {record.top4Info.length!==0 ? record.top4Info.map((item, index)=>{
                    return (
                      index===0 ? <div key={index} className="line_one hoverDiv" onClick={()=>{window.location.href = `#/detail/${item.id}`}}>
                        <div className="one_icon">
                          {item.photos ? <img src={item.photos[0]}/> : null}
                        </div>
                        <div className="left">
                          <div className="title">{item.title}</div>
                          <div className="description">{FormatRichText(item.html)}</div>
                        </div>
                      </div> : <div className="line_other hoverDiv" key={index} onClick={()=>{window.location.href = `#/detail/${item.id}`}}>
                        <span>·</span>
                        <div>{item.title}</div>
                      </div>
                    )
                  }) : <div className="card_null">
                    <img src={require('../../assets/icon/icon_null.png')}/>
                    <div className="null_text">没有数据...</div>
                  </div>}
                </div>
              )
            })
          }
        </div>
        <div className="inner_voice">
          <div className="left_list">
            <div className="list_title">
              <div className="title">内部心声</div>
              <div className="more hoverDiv"  onClick={()=>{window.location.href = '#/aspirations'}}>MORE</div>
            </div>
            <div className="main">
              {innerVoice&&innerVoice.map((record, index) => {
                return (
                  <div key={index} className="inline_line">
                    {record.data.map((vo, key)=>{
                      return (
                        key===0 ? <div key={key} className={`item hoverDiv`} onClick={()=>{window.location.href = `#/detail/${vo.id}`}}>
                          <div className="img"><img src={vo.photos&&vo.photos[0]}/></div>
                          <div className="title">{vo.title}</div>
                        </div> : <div className="line_other hoverDiv" key={key} onClick={()=>{window.location.href = `#/detail/${vo.id}`}}>
                          <div className="left_txt">
                            <span>·</span>
                            <div>{vo.title}</div>
                          </div>
                          <div className="right_topic">{vo.topic&&vo.topic.name}</div>
                        </div>
                      )
                    })}
                  </div>
                )
              })}
            </div>
          </div>
          <div className="right_ranking">
            <div className="title">TOP10 热门榜</div>
            {topTen&&topTen.top10Info&&topTen.top10Info.map((vo, index)=>{
              return (
                <div className="line_item hoverDiv" key={index} onClick={()=>{window.location.href = `#/detail/${vo.id}`}}>
                  <div>{vo.title}</div>
                  <div>{vo.user&&vo.user.nickname}</div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="video_list">
          <div className="list_title">
            <div className="title">热门视频</div>
          </div>
          <div className="list">
            {hotVideo&&hotVideo.map((vo, index)=>{
              return (
                <div className="item" key={index}>
                  <div className="box">
                    <video
                      src={vo.videoUrl}
                      controls
                      poster={vo.coverUrl}
                    />
                  </div>
                  <div className="title">{vo.name}</div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
